export const projects = [
    {
        appName: "Strapi Shop",
        appSkills: [
            "ReactJS",
            "MaterialUI",
            "Strapi",
            "Stripe API",
            "Postgres",
        ],
        appDescription: [
            "Created a robust full stack ecommerce website with ReactJS and Strapi",
            "incorporated Stripe API for handling payments",
        ],
        appCodeLink: "https://github.com/vikramsingh13/strapi-shop",
        appLiveLink: "#",
        appImage: "strapi_shop.PNG",
    },
    {
        appName: "Flask Weather App",
        appSkills: [
            "ReactJS",
            "Python",
            "Flask",
            "Open Weather API",
            "Vercel",
        ],
        appDescription: [
            "Created a micro web api with Flask",
            "incorporated Open Weather API for handling weather requests",
            "deployed on vercel"
        ],
        appCodeLink: "https://github.com/vikramsingh13/weather-app",
        appLiveLink: "https://weather-app.vikramsingh.tech/",
        appImage: "flask_weather_app.PNG",
    },
];
